/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Auth } from 'app/scripts/db/Auth';
import { Util } from 'app/scripts/lib/util';
import { searchFilter } from 'app/scripts/lib/util/text/search-filter';
import type { Board } from 'app/scripts/models/board';
import type { Member } from 'app/scripts/models/member';
import { View } from 'app/scripts/views/internal/view';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { MemberOnBoardView } from 'app/scripts/views/member-menu-profile/MemberOnBoardView';
import { PopoverBoardHeaderAllMembersTemplate } from 'app/scripts/views/templates/PopoverBoardHeaderAllMembersTemplate';
import {
  dialogProps,
  LazyBoardInviteModal,
} from 'app/src/components/BoardInviteModal';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

class BoardHeaderAllMembersView extends View<Board> {
  memberSearch?: string;
  static initClass() {
    this.prototype.viewTitleKey = 'board members';
  }

  events() {
    return {
      'input .js-search-board-member': 'onSearchEvent',
      'click .js-invite-to-board-link': 'renderInvitationLink',
    };
  }

  renderMembers(visibleMembers?: Member[]) {
    let member;
    if (visibleMembers == null) {
      visibleMembers = this.model.orderedVisibleMembers();
    }
    const hasOrg = this.model.get('idOrganization') != null;
    const org = this.model.getOrganization();

    const me = Auth.me();
    const isAffiliated =
      this.model.isMember(me) ||
      this.model.isObserver(me) ||
      (org != null ? org.isMember(me) : undefined);

    const groups = isAffiliated
      ? _.groupBy(visibleMembers || [], (member) => {
          const membership = this.model.getMembershipFor(member);
          const isWorkspaceAdmin = org?.isAdmin(member);
          if (this.model.isVirtual(member)) {
            return 'invited';
          } else if (membership == null) {
            return 'other';
          } else if (membership.deactivated) {
            return 'deactivated';
          } else if (
            membership.memberType === 'observer' &&
            !isWorkspaceAdmin
          ) {
            return 'observer';
          } else if (
            membership.orgMemberType != null ||
            (org != null ? org.getMembershipFor(member) : undefined) != null
          ) {
            return 'team';
          } else if (!hasOrg) {
            return 'member';
          } else {
            return 'other';
          }
        })
      : // If we're not affiliated with the board/team (e.g. it's a public board)
        // then we don't need to differentiate between the different sorts of
        // members
        {
          member: _.filter(visibleMembers || [], (member) => {
            const membership = this.model.getMembershipFor(member);
            return (
              !membership.deactivated && membership.memberType !== 'observer'
            );
          }),
        };

    const memberGroups = [
      { selector: '.js-list-members', list: groups.member },
      { selector: '.js-list-team-members', list: groups.team },
      { selector: '.js-list-invited-members', list: groups.invited },
      { selector: '.js-list-guests', list: groups.other },
      { selector: '.js-list-observers', list: groups.observer },
      { selector: '.js-deactivated-members', list: groups.deactivated },
    ];

    const hideHeadings =
      _.keys(groups).length === 1 &&
      (groups.member != null || groups.team != null);
    const rowMax = 8;

    for (const { selector, list = [] } of memberGroups) {
      const $section = $(selector, this.$el);
      const $list = $section.find('.js-list');
      const $heading = $section.find('.js-heading');

      $section.toggleClass('is-hidden', list.length === 0);
      $heading.toggleClass('is-hidden', hideHeadings);
      $section.toggleClass('is-partial-row', list.length < rowMax);

      const subviews = (() => {
        const result = [];
        for (member of list) {
          result.push(
            this.subview(MemberOnBoardView, member, {
              board: this.model,
              pushView: true,
            }),
          );
        }
        return result;
      })();

      if ($list.length) {
        this.ensureSubviews(subviews, $list);
      }
    }

    return this.defer(() => DragSort.refreshDraggableBoardMembers());
  }

  filterMembersResult(term: string) {
    const satisfiesSearch = searchFilter(term);

    return _.filter(this.model.orderedVisibleMembers(), (member) => {
      return satisfiesSearch(Util.getMemNameArray(member));
    });
  }

  onSearchEvent(e: Event) {
    this.memberSearch = ($(
      '.js-search-board-member',
      this.$el,
    ).val() as string).trim();

    const membersToRender = this.memberSearch
      ? this.filterMembersResult(this.memberSearch)
      : this.model.orderedVisibleMembers();

    $('.js-invite-no-results', this.$el).toggleClass(
      'hide',
      membersToRender.length !== 0,
    );
    return this.renderMembers(membersToRender);
  }

  renderInvitationLink(e: Event) {
    stopPropagationAndPreventDefault(e);
    Analytics.sendClickedLinkEvent({
      linkName: 'inviteToBoardLinkV2',
      source: 'allBoardMembersInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.getOrganization()?.id,
        },
      },
    });

    Dialog.show({
      reactElement: (
        <ComponentWrapper>
          <LazyBoardInviteModal
            idBoard={this.model.id}
            idOrg={this.model.getOrganization()?.id}
            onClose={Dialog.hide}
          />
        </ComponentWrapper>
      ),
      ...dialogProps,
    });
  }

  render() {
    const data = {
      canAssign: this.model.editable(),
      showInviteLink: this.model.canInviteMembers(),
    };

    this.$el.html(PopoverBoardHeaderAllMembersTemplate(data));

    this.renderMembers();

    Analytics.sendScreenEvent({
      name: 'allBoardMembersInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.getOrganization()?.id,
        },
      },
      attributes: {
        numMembers: this.model.orderedVisibleMembers().length,
      },
    });

    return this;
  }
}

BoardHeaderAllMembersView.initClass();
export { BoardHeaderAllMembersView };
